import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getCopyright = gql`
  ${seoFragment}
  query GetCopyright($site: [String]) {
    copyrightPageEntries(site: $site) {
      ... on copyrightPage_Entry {
        id
        seo {
          ...SeoFragment
        }
        title
        sezioneContenutoPagina {
          ... on testo_Entry {
            text
          }
          ... on immagine_Entry {
            custom: immagine @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
          ... on immagineTradotta_Entry {
            custom: immagineTradotta @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
        }
      }
    }
  }
`
